import React from 'react';
import { Helmet } from 'react-helmet';
import GooglePlayBadge from '../GooglePlayBadge/GooglePlayBadge';
import './AppPage.css';

const NovelAppPage = () => {
  return (
    <>
      <Helmet>
        <title>Novels & Books English-Offline - Free Reading App | Nirmal Labs</title>
        <meta name="description" content="Download Novels & Books English-Offline app. Read 100+ popular English novels and books offline. 1M+ downloads, 4.6 rating. Free Android app with text-to-speech." />
        <meta name="keywords" content="novels app, English books, offline reading, free books, English novels, reading app, books app, text to speech, classic literature" />
        <meta property="og:title" content="Novels & Books English Offline - Free Reading App" />
        <meta property="og:description" content="Read thousands of free English novels and books offline. Download from Google Play Store." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://nirmallabs.com/novel" />
        <meta property="og:image" content="https://nirmallabs.com/images/novel-app-screenshot.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Novels & Books English Offline - Free Reading App" />
        <meta name="twitter:description" content="Read thousands of free English novels and books offline. Download from Google Play Store." />
        <meta name="twitter:image" content="https://nirmallabs.com/images/novel-app-screenshot.jpg" />
        <link rel="canonical" href="https://nirmallabs.com/novel" />
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MobileApplication",
            "name": "Novels & Books English Offline",
            "description": "Read thousands of free English novels and books offline",
            "applicationCategory": "BookApplication",
            "operatingSystem": "Android",
            "offers": {
              "@type": "Offer",
              "price": "0",
              "priceCurrency": "USD"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.6",
              "ratingCount": "2100"
            }
          })}
        </script>
      </Helmet>

      <div className="app-page">
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <img 
                src="https://ik.imagekit.io/l9paoajth/app_logos/logo_novel.webp?updatedAt=1759892173676&tr=w-120,h-120" 
                alt="Novel App Icon" 
                className="app-icon"
                onError={(e) => {
                  e.target.src = 'https://via.placeholder.com/120x120/31B8D6/FFFFFF?text=N';
                }}
              />
              <h1>Novels & Books English-Offline</h1>
              <p className="hero-description">
                Large collection of public domain Books and Novels in English with multiple categories. 
                Fully functional without internet. Perfect for book lovers and literature enthusiasts.
              </p>
              <div className="download-buttons">
                <GooglePlayBadge 
                  href="https://play.google.com/store/apps/details?id=com.nirmallabs.novelsbooksinenglish"
                  size="large"
                  ariaLabel="Download Novel App from Google Play Store"
                />
              </div>
              <div className="app-stats">
                <span className="downloads">1M+ Downloads</span>
                <span className="rating">⭐ 4.6 Rating</span>
                <span className="category">Books & Reference</span>
              </div>
            </div>
          </div>
        </section>

        <section className="features-section">
          <div className="container">
            <h2>Key Features</h2>
            <div className="features-grid">
              <div className="feature-card">
                <h3>100+ Popular Books</h3>
                <p>More than 100 of the most popular Novels and Books in English including classics like Pride and Prejudice, Oliver Twist, Alice's Adventures in Wonderland</p>
              </div>
              <div className="feature-card">
                <h3>Text-to-Speech</h3>
                <p>Listen to your favorite novels anytime, hands-free. Perfect for reading on the go, during commutes, or while relaxing</p>
              </div>
              <div className="feature-card">
                <h3>Offline Reading</h3>
                <p>App fully functional without internet. Fast and responsive user interface with search capabilities</p>
              </div>
              <div className="feature-card">
                <h3>Reading Tools</h3>
                <p>Bookmark your favourite novels, share feature to send books to friends, smooth navigation</p>
              </div>
            </div>
          </div>
        </section>

        <section className="screenshots-section">
          <div className="container">
            <h2>App Screenshots</h2>
            <div className="screenshots-carousel">
              <img src="/images/novel-screenshot-1.jpg" alt="Novel App Library" />
              <img src="/images/novel-screenshot-2.jpg" alt="Novel App Reading View" />
              <img src="/images/novel-screenshot-3.jpg" alt="Novel App Book Details" />
            </div>
          </div>
        </section>

        <section className="description-section">
          <div className="container">
            <h2>About Novels & Books English Offline</h2>
            <p>
              Our Novels & Books English Offline app provides access to thousands of free English 
              novels and books that you can download and read without an internet connection. 
              Perfect for book lovers who want to read anywhere, anytime.
            </p>
            <p>
              The app features a user-friendly interface, customizable reading settings, and a 
              vast collection of literature from various genres including fiction, non-fiction, 
              classics, and contemporary works.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default NovelAppPage;
